(() => {
  const selector = '[data-mayhem-header-input]';
  let opening = false;
  const selectedVehicle = () => Boolean(window.TWGFitmentPreview?.selectedVehicle());
  const openSearch = field => {
    // Vehicle searches use the full finder, which evaluates exact configurations.
    if (selectedVehicle()) return false;
    const modal = document.getElementById('search-modal');
    const dialog = modal?.querySelector('dialog');
    const input = modal?.querySelector('input[ref="searchInput"]');
    if (!dialog || !input || typeof modal.showDialog !== 'function') return false;
    if (opening) return true;
    opening = true;
    input.value = field?.value || '';
    modal.showDialog();
    requestAnimationFrame(() => {
      opening = false;
      if (!dialog.open) return;
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    return true;
  };
  document.addEventListener('submit', event => {
    const form = event.target.closest?.('[data-mayhem-header-search]');
    if (!form) return;
    const field = form.querySelector(selector);
    // Enter or a search-button click with a term always has a native GET fallback.
    if (field?.value.trim()) return;
    if (openSearch(field)) event.preventDefault();
  });

  const menus = new WeakMap();
  let menuId = 0;
  const setupSuggestions = field => {
    if (menus.has(field)) return menus.get(field);
    const form = field.closest('[data-mayhem-header-search]');
    const panel = document.createElement('div');
    panel.className = 'mayhem-header-suggestions';
    panel.id = 'mayhem-header-suggestions-' + (++menuId);
    panel.hidden = true;
    panel.setAttribute('aria-label', 'Search suggestions');
    form.append(panel);
    field.setAttribute('aria-controls', panel.id);
    field.setAttribute('aria-expanded', 'false');
    const state = {panel, version: 0, timer: null};
    menus.set(field, state);
    return state;
  };
  const closeSuggestions = field => {
    const state = menus.get(field);
    if (!state) return;
    state.version++;
    clearTimeout(state.timer);
    state.panel.hidden = true;
    field.setAttribute('aria-expanded', 'false');
  };
  const showSuggestions = async field => {
    const state = setupSuggestions(field);
    const query = field.value.trim();
    const version = ++state.version;
    if (query.length < 2) { closeSuggestions(field); return; }
    const panel = state.panel;
    panel.hidden = false;
    field.setAttribute('aria-expanded', 'true');
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.textContent = 'Searching…';
    panel.replaceChildren(status);
    const search = new URL(field.form.action, location.origin);
    search.searchParams.set('q', query);
    search.searchParams.set('type', 'product');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) search.searchParams.set('preview_theme_id', preview);
    const more = document.createElement('a');
    more.className = 'mayhem-header-suggestions__more';
    more.href = search.href;
    more.textContent = 'View all results';
    panel.append(more);
    try {
      const service = window.MayhemSearchSuggestions;
      if (!service) throw new Error('Search loading');
      const rows = window.MayhemWheelSearch?.vehicleQuery(query) ? [] : await service.search(query);
      if (version !== state.version) return;
      const list = document.createElement('div');
      for (const row of rows) {
        const link = document.createElement('a');
        link.className = 'mayhem-header-suggestions__item';
        const url = new URL(row.url, location.origin);
        url.searchParams.set('variant', row.variantId);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.href;
        if (row.image) {
          const img = document.createElement('img');
          img.src = row.image; img.alt = ''; img.width = 48; img.height = 48;
          link.append(img);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = row.title;
        const detail = document.createElement('span');
        detail.textContent = [row.finish, row.size, row.boltOption, row.offset !== null && row.offset !== undefined && row.offset !== '' ? `${row.offset} mm offset` : '', row.sku ? `Part # ${row.sku}` : ''].filter(Boolean).join(' · ');
        copy.append(title, detail); link.append(copy); list.append(link);
      }
      status.textContent = rows.length ? 'Showing ' + rows.length + (rows.length === 1 ? ' matching configuration' : ' matching configurations') :
        window.MayhemWheelSearch?.vehicleQuery(query) ? 'View results to choose your vehicle.' : 'No matching wheels found.';
      panel.insertBefore(list, more);
    } catch {
      if (version === state.version) status.textContent = 'View all results to continue searching.';
    }
  };
  document.addEventListener('input', event => {
    const field = event.target;
    if (!field.matches?.(selector)) return;
    const state = setupSuggestions(field);
    state.version++;
    clearTimeout(state.timer);
    if (field.value.trim().length < 2) { closeSuggestions(field); return; }
    state.timer = setTimeout(() => showSuggestions(field), 200);
  });
  document.addEventListener('focusin', event => {
    if (event.target.matches?.(selector) && event.target.value.trim().length >= 2) showSuggestions(event.target);
  });
  document.addEventListener('focusout', event => {
    const form = event.target.closest?.('[data-mayhem-header-search]');
    if (form && !form.contains(event.relatedTarget)) closeSuggestions(form.querySelector(selector));
  });
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll(selector).forEach(field => {
      if (!field.form.contains(event.target)) closeSuggestions(field);
    });
  });
  document.addEventListener('keydown', event => {
    const form = event.target.closest?.('[data-mayhem-header-search]');
    if (!form) return;
    const field = form.querySelector(selector);
    const state = menus.get(field);
    if (!state || state.panel.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault(); field.focus(); closeSuggestions(field); return;
    }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    const links = [...state.panel.querySelectorAll('a')];
    const index = links.indexOf(event.target);
    const next = event.key === 'ArrowDown' ? index + 1 : index - 1;
    event.preventDefault();
    if (next < 0) field.focus(); else links[Math.min(next, links.length - 1)]?.focus();
  });

  const describeCards = root => {
    root.querySelectorAll?.('.resource-card img[alt^="TWG lug media | slots "]').forEach(img => {
      const card = img.closest('.resource-card');
      const title = card?.querySelector('.resource-card__title')?.textContent.trim();
      if (!title) return;
      img.dataset.mayhemMediaRouting ||= img.alt;
      img.alt = title;
    });
  };
  const start = () => {
    describeCards(document);
    new MutationObserver(records => records.forEach(record => {
      if (record.target instanceof Element) describeCards(record.target.closest('.resource-card') || record.target);
    })).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
